export default __webpack_public_path__ + "static/media/PowerNation.5bd085ae.svg";